/**
 * Título e etiqueta automáticos pelo tipo do card (Televendas ↔ Logística, 29/10/2026).
 * Config na etapa de abertura:
 *   tituloAutomatico: { campoTipo, modelos: { "<opção>": ["[Rastreio]", "NF nº {campo_x}", "Cliente {campo_y}"] } }
 *     → cada parte é juntada com " - "; parte cujo campo está vazio é pulada.
 *   etiquetaPorCampo: { campoId, mapa: { "<opção>": "<id da etiqueta do fluxo>" } }
 * O servidor aplica a mesma regra ao salvar (_titulo_e_etiqueta_automaticos em server.py).
 */
export const textoDoValor = (v: any): string =>
  (Array.isArray(v) ? v.map(textoDoValor).join(', ') : String(v ?? ''))
    .replace(/<[^>]*>/g, ' ').replace(/&nbsp;/gi, ' ').replace(/\s+/g, ' ').trim();

export const tituloAutomatico = (cfg: any, valores: Record<string, any>): string | null => {
  if (!cfg || !cfg.campoTipo) return null;
  const partes: string[] | undefined = cfg.modelos?.[textoDoValor(valores[cfg.campoTipo])];
  if (!partes) return null;
  const saida: string[] = [];
  for (const parte of partes) {
    let vazio = false;
    const t = parte.replace(/\{([A-Za-z0-9_]+)\}/g, (_m, id) => {
      const v = textoDoValor(valores[id]);
      if (!v) vazio = true;
      return v;
    });
    if (!vazio) saida.push(t);
  }
  return saida.join(' - ') || null;
};

export const etiquetasAutomaticas = (cfg: any, valores: Record<string, any>, atuais: string[] = []): string[] => {
  if (!cfg || !cfg.campoId || !cfg.mapa) return atuais;
  const todas = new Set(Object.values(cfg.mapa as Record<string, string>));
  const alvo = (cfg.mapa as Record<string, string>)[textoDoValor(valores[cfg.campoId])];
  const resto = atuais.filter((id) => !todas.has(id));
  return alvo ? [...resto, alvo] : resto;
};
